var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27612 8.5887L11.138 13.4642L10.1952 14.4096L4.3905 8.5887L10.1952 2.76782L11.138 3.71325L6.27612 8.5887Z",
    fill: "#7A858D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2761 8.5887L16.138 13.4642L15.1952 14.4096L9.3905 8.5887L15.1952 2.76782L16.138 3.71325L11.2761 8.5887Z",
    fill: "#7A858D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPage);
export default __webpack_public_path__ + "static/media/first-page.b8929c11572815781ffeb6d88f4ea44e.svg";
export { ForwardRef as ReactComponent };